import React from 'react';
import * as PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './Hr.module.scss';

const Hr = ({ text, className, color, style, ...otherProps }) => {
    return (
        <hr
            className={cx('my-4', className, {
                [styles.hrWithText]: text,
                [color]: color,
                'border-ui-gray-300': !color,
            })}
            style={style}
            data-content={text}
            {...otherProps}
        />
    );
};

Hr.defaultProps = {
    text: null,
    color: null,
};

Hr.propTypes = {
    text: PropTypes.string,
    className: PropTypes.string,
    color: PropTypes.string,
    style: PropTypes.object,
};

export default Hr;
